'use strict';

var router = require('./router');

module.exports = router;
